import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as assignee from '../assignee'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: assignee.RESOURCE.payload.dimension.partialId,
      partialId: assignee.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    default: false,
    description:
      'Assignee is ultimately accountable for success or failure in achieving this outcome',
    isOptional: false,
    name: 'Is Accountable',
    partialId: PartialId.Standard.create('is_accountable'),
    type: core.common.value.types.Intrinsic.Boolean,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
